package com.rosario.juridico.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.functions.functions
import dev.gitlive.firebase.initialize

object FirebaseWeb {
    private var isInitialized = false

    val auth by lazy {
        initializeIfNeeded()
        Firebase.auth
    }

    val firestore by lazy {
        initializeIfNeeded()
        Firebase.firestore
    }

    val functions by lazy {
        initializeIfNeeded()
        // Configuración para Gen 2: Especificar región explícitamente si es necesario
        Firebase.functions("us-central1")
    }

    fun initializeIfNeeded() {
        if (!isInitialized) {
            try {
                // Configuración para Web basada en google-services.json y entorno
                val options = FirebaseOptions(
                    apiKey = "AIzaSyA__op_xx8j0CzqJQcRjN8XYKgrJE--1t0",
                    applicationId = "1:1048671261828:web:b1d8e120f2628424c41ed1", // ID web por defecto para este proyecto
                    projectId = "juridico5",
                    authDomain = "juridico5.firebaseapp.com",
                    storageBucket = "juridico5.firebasestorage.app"
                )
                // Inyectamos el Client ID explícitamente para asegurar que los proveedores de Auth lo reconozcan en Web
                options.asDynamic().clientId = "1048671261828-i158fjrcaopfk19fu4hh9i52u5nu3rcg.apps.googleusercontent.com"

                Firebase.initialize(options = options)
                isInitialized = true
            } catch (e: Exception) {
                // Si ya estaba inicializado por otro medio
                isInitialized = true
            }
        }
    }
}
